import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';

import './assets/css/bootstrap.min.css';
import './assets/css/line-awesome.css';
import './assets/css/owl.carousel.min.css';
import './assets/css/owl.theme.default.min.css';
import './assets/css/magnific-popup.css';
import './assets/css/daterangepicker.css';
import './assets/css/jquery-ui.css';
import './assets/css/chosen.min.css';
import './assets/css/style.css';

ReactDOM.render(

  <BrowserRouter>
    <App />
  </BrowserRouter>,
  
  document.getElementById('root')

);

reportWebVitals();
